import { getPrincipleSource, getPrincipleStatus } from "common/un-principles-helper";
export const valueMapper = (series) => {
    if (series) {
        return series.filter((measure) => measure?.name).map((measure) => {
            const returnObject = {
                principle: measure?.name?.toString()?.toUpperCase() || "",
                violationStatus: getPrincipleStatus(measure?.y?.toString())
            };
            const source = getPrincipleSource(measure?.y?.toString());
            if (source) {
                returnObject.violationSource = source;
            }
            return returnObject;
        });
    }
    return [];
};
